"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const utils_1 = require("../utils");
const styled_1 = __importDefault(require("../utils/styled"));
const Input_Button_1 = __importDefault(require("./Input.Button"));
const Input_constants_1 = require("./Input.constants");
const Icon_1 = require("../Icon");
const getMaxWidth = (fullWidth, statusIcon) => {
    if (fullWidth && statusIcon) {
        return `calc(100% - ${Input_constants_1.iconBoxSize}px)`;
    }
    if (fullWidth) {
        return "none";
    }
    return `${Input_constants_1.width}px`;
};
const Container = styled_1.default.div `
  position: relative;
  align-items: center;
  justify-content: center;
  display: inline-flex;
  width: 100%;
  max-width: ${({ fullWidth, statusIcon }) => getMaxWidth(fullWidth, statusIcon)};
`;
const Field = styled_1.default("input")(({ theme, disabled, isError, withIconButton, preset, clear, isUniqueId }) => {
    const makeBackgroundColor = () => {
        if (disabled) {
            return theme.color.disabled;
        }
        if (preset) {
            return utils_1.setAlpha(0.1)(theme.color.primary);
        }
        return theme.color.white;
    };
    const getFontWeight = () => {
        if (isUniqueId) {
            return theme.font.weight.bold;
        }
        if (preset) {
            return theme.font.weight.medium;
        }
        return theme.font.weight.regular;
    };
    const getRightPadding = () => {
        if (clear && isUniqueId) {
            return Input_constants_1.iconBoxSize + theme.space.big;
        }
        if (clear || isUniqueId) {
            return Input_constants_1.iconBoxSize;
        }
        return theme.space.small;
    };
    return Object.assign({}, (withIconButton
        ? { borderTopRightRadius: theme.borderRadius, borderBottomRightRadius: theme.borderRadius, marginLeft: -1 }
        : { borderRadius: theme.borderRadius }), { font: isUniqueId ? "none" : "inherit", fontFamily: isUniqueId ? theme.font.family.code : "inherit", fontWeight: getFontWeight(), fontSize: theme.font.size.small, width: "100%", height: Input_constants_1.height, label: "input", flexGrow: 1, padding: `${theme.space.small}px ${getRightPadding()}px ${theme.space.small}px ${theme.space.medium}px`, opacity: disabled ? 0.6 : 1.0, border: "none", boxShadow: `0 0 0 1px ${isError ? theme.color.error : theme.color.border.default}`, margin: "0 1px", outline: "none", appearance: "none", color: preset ? theme.color.text.dark : theme.color.text.default, backgroundColor: makeBackgroundColor(), "::placeholder": {
            color: theme.color.text.disabled,
        }, ":focus": utils_1.inputFocus({ theme, isError }) });
});
const ClearButton = styled_1.default.div `
  /* We also probably should specify the dimensions of this box */
  width: ${Input_constants_1.iconBoxSize}px;
  height: ${Input_constants_1.iconBoxSize}px;

  /* Also, let's center the contents of this box */
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer; /* Let the user know this is clickable */

  outline: none;
  :focus {
    ${({ theme }) => utils_1.inputFocus({
    theme,
})}
  }

  /* We want the user to click on thix _box_, not the icon inside it */
  > svg {
    pointer-events: none;
  }
`;
const IconContainer = styled_1.default.div `
  position: absolute;
  top: 0; /* anchor the position to the top so the browser doesn't guess */
  right: ${({ right }) => right}px;

  /* Dimensions of the container */
  width: ${({ iconAmount }) => iconAmount * Input_constants_1.iconBoxSize}px;
  height: ${Input_constants_1.iconBoxSize}px;

  /* Also, let's center the contents of this box */
  display: flex;
  align-items: center;
  justify-content: center;
`;
const UniqueIdIcon = styled_1.default(Icon_1.IDIcon) `
  color: ${({ theme }) => theme.color.text.lightest};
`;
const InputField = (_a) => {
    var { id, hint, fullWidth, inputRef, autoFocus, name, autoComplete, disabled, value, type, onFocus, onBlur, placeholder, error, onChange, preset, label, clear, icon, copy, onIconClick, tabIndex, errorComponent: ErrorComponent, isUniqueId, statusIcon, placeholderIcon } = _a, props = __rest(_a, ["id", "hint", "fullWidth", "inputRef", "autoFocus", "name", "autoComplete", "disabled", "value", "type", "onFocus", "onBlur", "placeholder", "error", "onChange", "preset", "label", "clear", "icon", "copy", "onIconClick", "tabIndex", "errorComponent", "isUniqueId", "statusIcon", "placeholderIcon"]);
    const shouldShowIconButton = Boolean(icon) || Boolean(copy);
    const renderButton = () => {
        if (copy === true) {
            return React.createElement(Input_Button_1.default, { tabIndex: tabIndex, value: value || "", copy: copy });
        }
        else {
            return React.createElement(Input_Button_1.default, { tabIndex: tabIndex, onIconClick: onIconClick, icon: icon, copy: false });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, { fullWidth: fullWidth, statusIcon: statusIcon },
            shouldShowIconButton && renderButton(),
            React.createElement(Field, Object.assign({ "data-cy": "operational-ui__Input", ref: inputRef, autoFocus: autoFocus, name: name, disabled: Boolean(disabled), value: value || "", type: type, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder, isError: Boolean(error), onChange: (ev) => {
                    if (onChange) {
                        ev.stopPropagation();
                        onChange(ev.currentTarget.value);
                    }
                }, clear: clear, preset: Boolean(preset), id: `input-field-${id}`, withIconButton: shouldShowIconButton, autoComplete: autoComplete, tabIndex: tabIndex, isUniqueId: isUniqueId }, props)),
            React.createElement(IconContainer, { iconAmount: placeholderIcon && !value ? 1 : 0, right: 0 }, !value && placeholderIcon),
            React.createElement(IconContainer, { iconAmount: (clear && value ? 1 : 0) + (isUniqueId ? 1 : 0), right: 0 },
                clear && value && (React.createElement(ClearButton, { "data-cy": "operational-ui__Input-clear-button", "aria-label": "Clear Input", tabIndex: 0, onClick: clear },
                    React.createElement(Icon_1.NoIcon, { size: 10 }))),
                isUniqueId && React.createElement(UniqueIdIcon, null)),
            Boolean(statusIcon) && (React.createElement(IconContainer, { "data-cy": "operational-ui__Input-status-icon", iconAmount: 1, right: -Input_constants_1.iconBoxSize }, statusIcon)),
            error && !ErrorComponent ? React.createElement(utils_1.FormFieldError, null, error) : null),
        error && ErrorComponent ? React.createElement(ErrorComponent, { errorMessage: error }) : null));
};
exports.default = InputField;
//# sourceMappingURL=Input.Field.js.map